import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: recoveryReset } = actions;

export * from './thunks';
export * as passwordRecoverySelectors from './selectors';

export default reducer;
